import {IResponse, requestWithToken} from "./RequestBase";
import {config} from "../config";

export const fetchPublicLinks = async (): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.baseurl}/api/settings/links`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
        },
        false
    );

    return data;
}

export const fetchCreatePublicLink = async (name: string): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.baseurl}/api/settings/create-link`,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({name: name, startDate: null, endDate: null})
        },
        false
    );
    return data;
}

export const fetchFilesByPublicLink = async (name: string): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.baseurl}/api/settings/file-link/${name}`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
        },
        false
    );
    return data;
}

export const fetchDeletePublicLink = async (name: string): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.baseurl}/api/settings/delete-link/${name}`,
        {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
            },
        },
        false
    );
    return data;
}

export const fetchDeletePublicLinkFile = async (name: string, id: number): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.baseurl}/api/settings/delete-file-from-link`,
        {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({publicLink: name, fileId: id})
        },
        false
    );
    return data;
}

export const fetchAddFileToPublicLink = async (name: string, id: number): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.baseurl}/api/settings/add-file-to-link`,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({publicLink: name, fileId: id})
        },
        false
    );
    return data;
}

export const fetchUpdatePublicLink = async (name: string, enable: boolean): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.baseurl}/api/settings/update-link`,
        {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({name: name, enable: enable})
        },
        false
    );
    return data;
}

export const fetchFile2PublicLink = async (id: number): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.baseurl}/api/settings/public-link/${id}`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
        },
        false
    );
    return data;
}
